import { render } from "./maximizeView.vue?vue&type=template&id=32080310"
import script from "./maximizeView.vue?vue&type=script&lang=js"
export * from "./maximizeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__